import PropTypes from 'prop-types';
import React from 'react';
import { ChartPin } from '../../common';
import { formatValue } from '../../../lib/usage-formatters';
import I18n from '../../../lib/i18n';

const UsageChartPin = props => (
  <ChartPin
    text={I18n.t('used', { value: formatValue(props.value, props.unitType) })}
    color={props.color}
    style={props.style}
    reversed={props.reversed}
  />
);

UsageChartPin.propTypes = {
  value: PropTypes.number.isRequired,
  unitType: PropTypes.string.isRequired,
  reversed: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
};

export default UsageChartPin;
